<template>
  <el-dialog
      :visible.sync="showDialog"
      @close="handleCloseDialog"
      :close-on-click-modal="false">
    <template #title>
      <h4>{{ title }}</h4>
    </template>

    <el-form ref="form" :model="formData" :rules="rules" label-width="auto">
      <el-form-item :label="$t('名称')" prop="name">
        <el-input :placeholder="$t('请输入名称')" v-model="formData.name" :disabled="disabledName"  />
      </el-form-item>

      <el-form-item :label="$t('积分')" prop="integral">
        <el-input :placeholder="$t('请输入积分')" v-model.number="formData.integral"  />
      </el-form-item>

      <el-form-item :label="$t('描述')" prop="remark" v-if="type === 'level'">
        <el-input :placeholder="$t('请输入描述')" type="textarea" :rows="4" v-model="formData.remark"  />
      </el-form-item>

    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleSave">{{$t('确定')}}</el-button>
      <el-button @click="showDialog = false">{{$t('取消')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {resetEmpty} from "@/utils/common";

export default {
  name: "VipLevelForm",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "level", // level 等级 integral 积分
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        name: "",
        integral: null,
        remark: "",
      },
      rules: {
        name: {required: true, message: this.$t('请输入名称'), trigger: 'blur'},
        integral: [
          {required: true, message: this.$t('请输入积分'), trigger: 'blur'},
          {type: 'number', message: this.$t('积分必须为数字值'), trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    handleSave() {
      this.$refs.form.validate((valid) => {
        if(!valid) return;
        this.$emit("save", {...this.formData});
        this.showDialog = false;
      })
    },

    handleCloseDialog() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    }
  },
  watch: {
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      },
      immediate: true,
    }
  },
  computed: {
    // 如果是积分并且是编辑需要禁用昵称
    disabledName() {
      return this.type === "integral" && this.isEdit;
    }
  }
}
</script>

<style scoped>

/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
